import {randomId,View,withSequence} from "vritra";
import css from "./WithSequenceExample.module.css";
import {repeat0,arrow0} from "Assets";


export default function WithSequenceExample(props){
    const {parent,id=randomId("withsequenceexample")}=props;
    const withsequenceexample=View({parent,id,className:css.withsequenceexample}),state={
        horizontalDuration:withsequenceexample.offsetWidth/2,
        verticalDuration:withsequenceexample.offsetHeight,
    },{horizontalDuration,verticalDuration}=state;

    withsequenceexample.innateHTML=`
        <img class="button ${css.playbtn}" src="${repeat0(mainColor)}"/>
        <img class="${css.arrow}" src="${arrow0("white")}"/>
    `;

    const playbtn=withsequenceexample.querySelector(`.${css.playbtn}`);
    playbtn.onclick=function navigate(){
        playbtn.onclick=null;
        const rotateDuration=(horizontalDuration+verticalDuration)/2;
        const arrow=withsequenceexample.querySelector(`.${css.arrow}`);
        arrow.style.transform="rotateZ(0deg)";
        withSequence(arrow,[
            {toStyle:{left:"75%"},duration:horizontalDuration},
            {toStyle:{transform:"rotateZ(-90deg)"},duration:rotateDuration},
            {toStyle:{bottom:"100%"},duration:verticalDuration},
            {toStyle:{transform:"rotateZ(-180deg)"},duration:rotateDuration},
            {toStyle:{left:"25%"},duration:horizontalDuration},
            {toStyle:{transform:"rotateZ(-270deg)"},duration:rotateDuration},
            {toStyle:{bottom:"0"},duration:verticalDuration},
            {toStyle:{transform:"rotateZ(-360deg)"},duration:rotateDuration},
        ],()=>{
            playbtn.onclick=navigate;
        });
    }
    playbtn.onclick();

    return withsequenceexample;
}
